import { ActivatedRouteSnapshot } from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {ShipmentListService} from '../shipment-list.service';
import {promise} from 'protractor';

@Injectable()
export class ShipmentResolver  {
  constructor(private shipmentListService: ShipmentListService) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const query = route.paramMap.get('query');

    return this.shipmentListService.getShipment(query);
  }
}
